var React = require('react');

function Contact (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / contact"),React.createElement("g",{"id":"icons-/-contact","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M0,20 L24,20 L24,4 L0,4 L0,20 Z M3.707,6 L20.293,6 L12,12.714 L3.707,6 Z M16.073,11.989 L22,7.191 L22,16.805 L16.073,11.989 Z M2,7.191 L7.927,11.989 L2,16.805 L2,7.191 Z M14.485,13.275 L20.299,18 L3.701,18 L9.516,13.275 L12,15.287 L14.485,13.275 Z","id":"contact","fill":"#1E1E1E"}))]);
}

Contact.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Contact;

Contact.default = Contact;
